import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { ArrowRightOutlined, ClockCircleOutlined, DeleteOutlined, PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Drawer,
  Flex,
  Input,
  Layout,
  notification,
  Popconfirm,
  Progress,
  Row,
  Select,
  Space,
  Switch,
  Table,
  TimePicker,
  Typography,
} from "antd";
const { Option } = Select;
const { Content } = Layout;
const { Title, Text, Link } = Typography;

import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../Home/Loader/Loader";
import { issueRawMaterial } from "../../../redux/actions/API/bomRawMaterials";
import {
  getBulkProductions,
  removeRows,
  saveFinishedGoods,
  saveProduction,
  updateCost,
  updateProcess,
  updateProductionStatus,
  updateScrapLogsStatus,
  updateTableData,
} from "../../../redux/actions/API/production";
import {
  getAllStoresWithItems,
  getStores,
} from "../../../redux/actions/API/storesActions";
import { getUOM } from "../../../redux/actions/API/uomAction";
import "./viewProduction.css";
import { getItems } from "../../../redux/actions/API/items";
import { getProductionProcess } from "../../../redux/actions/API/productionProcess";
import { getAllRejectStoreItems } from "../../../redux/actions/API/stockTransferAction";
import { getUsers } from "../../../redux/actions/API/users";
import { getSetting } from "../../../redux/actions/API/settingAction";
import ColumnWidths from "../../utility/columnWidth";
import { isValidJSON } from "../../utility/itemsUtility";
import ProductionHistory from "./ProductionHistory";

interface IViewBulkProductionProps {
  getBulkProductions: Function;
  bulkProductionData: any;
  loading: boolean;
  getUOM: Function;
  getUsers: Function;
  companyId: string;
  UOMData: any;
  usersData: any[];
  getAllStoresWithItems: Function;
  getAllStoresWithItemsData: any;
  getStores: Function;
  storesData: any;
  issueRawMaterialLoading: boolean;
  issueRawMaterial: Function;
  updateProcessLoading: boolean;
  updateProcess: Function;
  updateCost: Function;
  updateCostLoading: boolean;
  saveFinishedGoods: Function;
  saveFinishedGoodsLoading: boolean;
  issueRawMaterialSuccess: string;
  productionUpdateMsg: string;
  costUpdateMsg: string;
  finishedGoodsMsg: string;
  updateProductionStatus: Function;
  updateProductionStatusMsg: string;
  updateProductionStatusLoading: boolean;
  updateScrapLogLoading: boolean;
  updateScrapLogsStatus: Function;
  updateScrapLogMsg: string;
  saveProductionLoading: boolean;
  saveProduction: Function;
  saveProductionMsg: string;
  itemsData: any;
  getItems: Function;
  updateTableData: Function;
  updateTableMsg: string;
  updateTableLoading: boolean;
  getProductionProcessState: any;
  getProductionProcess: Function;
  getAllRejectStoreItems: Function;
  getAllRejectStoreItemsData: any;
  userId: string;
  removeRows: Function;
  removeRowLoading: boolean;
  removeRowMsg: string;
  settingData: any;
  getSetting: Function;
}

const ViewBulkProduction: React.FC<IViewBulkProductionProps> = ({
  getBulkProductions,
  bulkProductionData,
  getUsers,
  usersData,
  loading,
  getUOM,
  companyId,
  UOMData,
  getAllStoresWithItems,
  getAllStoresWithItemsData,
  getStores,
  storesData,
  issueRawMaterialLoading,
  issueRawMaterial,
  updateProcess,
  updateProcessLoading,
  updateCost,
  updateCostLoading,
  saveFinishedGoods,
  saveFinishedGoodsLoading,
  issueRawMaterialSuccess,
  productionUpdateMsg,
  costUpdateMsg,
  finishedGoodsMsg,
  updateProductionStatusMsg,
  updateProductionStatus,
  updateProductionStatusLoading,
  updateScrapLogsStatus,
  updateScrapLogMsg,
  updateScrapLogLoading,
  saveProduction,
  saveProductionLoading,
  saveProductionMsg,
  itemsData,
  getItems,
  updateTableData,
  updateTableMsg,
  updateTableLoading,
  getProductionProcess,
  getProductionProcessState,
  getAllRejectStoreItemsData,
  getAllRejectStoreItems,
  userId,
  removeRowLoading, removeRowMsg, removeRows,
  settingData,
  getSetting
}) => {

  const query = new URLSearchParams(useLocation().search);
  const productionId = query.get('productionId');
  // const productionIds = location.state?.productionIds || [];

  const [showColumns, setshowColumns] = useState(false);
  const [drawerOpen, setIsDrawerOpen] = useState(false);
  const [uomMap, setUomMap] = useState<any>({});
  const [storewiseItems, setStoreWiseItems] = useState<any>({});
  const [rawMaterials, setRawMaterials] = useState<any>([]);
  const [finishedGoods, setFinishedGoods] = useState<any>([]);
  const [process, setProcess] = useState<any>([]);
  const [additionalCharges, setAdditionalCharges] = useState<any>([]);
  const [scrapLogs, setScrapLogs] = useState<any>([]);
  const [todaysProduction, setTodaysProduction] = useState(0);
  const [passedQty, setPassedQty] = useState(0);
  const [store, setStore] = useState("");
  const [rejectStore, setRejectStore] = useState("");
  const [productionStatus, setProductionStatus] = useState<any>(0);
  const [costOfProduction, setCostOfProduction] = useState(0);
  const [updateTable, setUpdateTable] = useState("");
  const [plannedQty, setPlannedQty] = useState(1);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [chargesName, setChargesName] = useState("");
  const [chargesCost, setChargesCost] = useState(0);
  const [selectedProcess, setSelectedProcesses] = useState("");
  const [plannedTime, setPlannedTime] = useState<any>("");
  const [addRows, setAddRows] = useState<any>([]);
  const [addCharges, setAddCharges] = useState<any>([]);
  const [addProcess, setAddProcess] = useState<any>([]);
  const [productions, setProductions] = useState<any[]>([]);
  const [finishedGoodMap, setFinishedGoodMap] = useState<any>({});
  const [rawMaterialMap, setRawMaterialMap] = useState<any>({});
  const [testIndex, setTestIndex] = useState<any>(null);
  const [userMap, setUserMap] = useState<any>({});
  const [openHistory, setOpenHistory] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    if (bulkProductionData && bulkProductionData?.length) {
      setProductions(bulkProductionData);
    }
  }, [bulkProductionData]);

  useEffect(() => {
    const obj = usersData?.reduce((acc: any, curr: any) => {
      acc[curr.id] = curr.name;
      return acc;
    }, {});
    setUserMap(obj);
  }, [usersData]);

  const finishedGoodColumns: any = [
    {
      title: '#',
      dataIndex: 'key',
      width: 50,
      render: (text: string, record: any, index: number) => <span>{index + 1}</span>
    },
    {
      title: 'Item Id',
      dataIndex: 'itemId',
      fixed: 'left',
    },
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
      render: (text: string, record: any) => {
        // const customFields = isValidJSON(record?.customFields) || {};
        // const fields = (Array.isArray(getCustomFieldsState?.data?.data) ? getCustomFieldsState?.data?.data : [])?.filter((fields: any) => {
        //     return fields?.documentType == 'documents' && fields?.level == 'Item Level'
        // });
        return <>
          <div>{text || record?.production?.productionItem?.itemName || ""}</div>
          {/* {
                        fields?.map((data: any) => {
                            const isVisible = isValidJSON(data?.visibleOn)?.includes('Sales Order');
                            return (isVisible && customFields?.[data?.fieldName]) ? <div>
                                {
                                    data?.fieldName + ': ' + customFields?.[data?.fieldName]
                                }
                            </div> : <></>
                        })
                    } */}
        </>
      },
    },
    {
      title: 'Production Id',
      dataIndex: 'ProductionId',
      key: 'ProductionId',
      render: (text: any, record: any) => {
        return <span onClick={() => {
          navigate(`/view_production?productionId=${record?.productionId}`)
        }} className="link">{record?.productionNumber}</span>
      }
    },

    {
      title: 'Store',
      dataIndex: 'store',
      width: ColumnWidths.MEDIUM,
      render: (text: string, record: any, index: number) => {
        return <Select style={{ width: '250px' }} onChange={(value: string) => {
          const arr = [...finishedGoods];
          arr[index] = {
            ...arr[index],
            store: value
          }
          setFinishedGoods(arr);
        }} placeholder='Select Store' className='input' value={record.store}>
          {
            (Array.isArray(storesData) ? storesData : [])?.map((store: any, index: number) => (
              <Option key={store.id} value={store.name}>{store.name}</Option>
            ))
          }
        </Select>
      }
    },
    {
      title: 'UOM',
      dataIndex: 'uom',
      render: (text: string, record: any) => {
        return <span>{uomMap?.[record?.uom]}</span>
      }
    },
    {
      title: 'Assigned To',
      dataIndex: 'assignedTo',
      render: (text: string, record: any, index: number) => {
        return <span>{userMap?.[bulkProductionData[index]?.production?.assignedTo]}</span>
      }
    },
    {
      title: 'Bom ID',
      dataIndex: 'bomId',
      render: (text: string, record: any, index: number) => {
        return <span>{bulkProductionData[index]?.bom?.bomId}</span>
      }
    },
    {
      title: 'Bom Name',
      dataIndex: 'bomName',
      render: (text: string, record: any, index: number) => {
        return <span>{bulkProductionData[index]?.bom?.bomName}</span>
      }
    },
    {
      title: 'Production Deadline',
      dataIndex: 'productionDeadline',
      render: (text: string, record: any, index: number) => {
        return <span>{bulkProductionData[index]?.production?.productionEndDate}</span>
      }
    },
    {
      title: 'Cost',
      dataIndex: 'cost',
      render: (text: string, record: any) => {
        return <span>{record?.cost}</span>
      }
    },
    {
      title: 'Available Qty',
      dataIndex: 'plannedQty',
      render: (text: string, record: any) => {
        return <span>{storewiseItems?.[record.store]?.[record.itemId] / (record?.conversionFactor || 1) || 0}</span>
      }
    },
    {
      title: 'Planned Qty',
      dataIndex: 'plannedQty',
      render: (text: string, record: any) => {
        return <span>{record?.quantity}</span>
      }
    },
    {
      title: 'Produced Qty',
      dataIndex: 'plannedQty',
      render: (text: string, record: any) => {
        return <span>{record?.producedQuantity || 0}</span>
      }
    },
    {
      title: 'Approved Qty',
      dataIndex: 'passedQty',
      render: (text: string, record: any) => {
        return <span>{record?.passedQuantity || 0}</span>
      }
    },
    {
      title: 'Defective Qty',
      dataIndex: 'rejectQuantity',
      render: (text: string, record: any) => {
        return <span>{record?.rejectQuantity || 0}</span>
      }
    },
    // {
    //   title: 'Quick Material Planning',
    //   dataIndex: 'quickMaterialPlanning',
    //   render: (text: string, record: any, index: number) => {
    //     return <Input
    //       type='number'
    //       style={{ width: '220px' }}
    //       placeholder='Enter Finished Goods Quantity'
    //       onChange={(e) => {
    //         const val = Number(e.target.value);
    //         const arr = [...finishedGoods];
    //         arr[0].todaysProduction = val;
    //         setFinishedGoods(arr);
    //         const scraps = [...scrapLogs];
    //         for (const element of scraps) {
    //           element.value = val * (element.quantity / finishedGoods[0].quantity);
    //         }
    //         setScrapLogs(scraps);
    //         const charges = [...additionalCharges];
    //         for (const element of charges) {
    //           element.todayCost = val * (element.amount / finishedGoods[0].quantity);
    //         }
    //         setAdditionalCharges(charges);

    //         const raw = [...rawMaterials];
    //         for (const element of raw) {
    //           const available = !element?.store ? 0 : !element?.isReject ? (storewiseItems?.[element.store]?.[element.itemId] / (element?.conversionFactor || 1) || 0) : (getAllRejectStoreItemsData?.[`${element?.store?.replaceAll("-fromrejectstore", "")}`]?.[element.itemId] || 0)
    //           element.issuedToday = (val * (element.quantity / finishedGoods[0]?.quantity))?.toFixed(2);
    //           if (available < val * (element.quantity / finishedGoods[0]?.quantity)) {
    //             element.error = true;
    //           }
    //           else element.error = false;
    //         }
    //         setRawMaterials(raw);
    //       }}
    //     />
    //   }
    // },
    {
      title: `Today's Production`,
      dataIndex: 'plannedQty',
      width: '250px',
      render: (text: string, record: any, index: number) => {
        return <Input value={record?.todaysProduction} className="input" type='number'
          onChange={(e) => {
            if (Number(e.target.value) < 0) return;
            const arr = [...finishedGoods];
            arr[index] = {
              ...arr[index],
              todaysProduction: Number(e.target.value)
            }
            setFinishedGoods(arr);
          }}
          placeholder='Enter Quantity' />
      }
    },
    {
      title: 'Testing',
      dataIndex: 'passedQty',
      fixed: 'right',
      render: (text: string, record: any, index: number) => {
        return <Button type='primary' onClick={() => {
          setIsDrawerOpen(true);
          setTestIndex(index);
          setPassedQty(record?.quantityToTest);
          setSelectedItemId(record.itemId);
        }}
          disabled={!record?.quantityToTest}
        >Test</Button>
      }
    },
  ];

  const rawMaterialColumns: any = [
    {
      title: '#',
      dataIndex: 'key',
      width: 50,
      render: (text: string, record: any, index: number) => <span>{index + 1}</span>
    },
    {
      title: 'Item Id',
      dataIndex: 'itemId',
      fixed: 'left',
    },
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
    },
    {
      title: 'Finished Good',
      dataIndex: 'finishedGood',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
      render: (text: any, record: any) => {
        return <span>{finishedGoodMap[record?.productionId]?.itemName}</span>
      }
    },
    // ...(
    //     Array.isArray(getCustomFieldsState?.data?.data)
    //         ? getCustomFieldsState.data.data
    //             .filter((field: any) => {
    //                 try {
    //                     const visibleOn = isValidJSON(field?.visibleOn) || [];
    //                     return visibleOn.includes('Production Raw Material');
    //                 } catch {
    //                     return false;
    //                 }
    //             })
    //             .map((field: any) => ({
    //                 title: field?.fieldName,
    //                 dataIndex: field?.fieldname,
    //                 width: '200px',
    //                 render: (text: string, record: any, index: number) => {
    //                     const customFields = isValidJSON(itemsMap[record?.itemId]?.customFields)
    //                     return <span>{customFields?.[field?.fieldName] || 'N/A'}</span>
    //                 }
    //             }))
    //         : []
    // ),
    {
      title: 'Store',
      dataIndex: 'store',
      width: ColumnWidths.MEDIUM,
      render: (text: string, record: any, index: number) => {
        return <Select
          style={{ width: '250px' }}
          onChange={(value: string) => {
            const arr = [...rawMaterials];
            let error = false;
            const isReject = value.includes('-fromrejectstore');
            const storeKey = isReject
              ? value.replace('-fromrejectstore', '')
              : value;
            const itemId = record.itemId;
            const conversionFactor = record?.conversionFactor || 1;
            const quantity = Number(record.issuedToday || 0); // or from elsewhere if needed
            const availableQty = isReject
              ? getAllRejectStoreItemsData?.[storeKey]?.[itemId] || 0
              : storewiseItems?.[storeKey]?.[itemId] || 0;
            if (availableQty / conversionFactor < quantity) {
              error = true;
            }
            arr[index] = {
              ...arr[index],
              store: value,
              isReject: isReject,
              error
            };
            setRawMaterials(arr);
          }}
          placeholder="Select Store"
          className="input"
          value={record.store}
        >
          {storesData?.map((store: any, index: number) => (
            <React.Fragment key={store.id}>
              {store?.storeType?.includes("1") && (
                <Option value={store.name}>
                  {store.name} (Instock)
                </Option>
              )}
              {store?.storeType?.includes("2") && (
                <Option value={`${store.name}-fromrejectstore`}>
                  {store.name} (Reject)
                </Option>
              )}
            </React.Fragment>
          ))}
        </Select>

      }
    },
    {
      title: 'UOM',
      dataIndex: 'uom',
      render: (text: string, record: any) => {
        return <span>{uomMap?.[record?.uom]}</span>
      }
    },
    {
      title: 'Available Qty',
      dataIndex: 'plannedQty',
      render: (text: string, record: any) => {
        return <span>{!record?.isReject ? (storewiseItems?.[record.store]?.[record.itemId] / (record?.conversionFactor || 1) || 0).toFixed(3) : (getAllRejectStoreItemsData?.[`${record?.store?.replaceAll("-fromrejectstore", "")}`]?.[record.itemId] || 0).toFixed(3)}</span>
      }
    },
    {
      title: <div style={{ display: 'flex', alignItems: 'center' }}>
        Planned Qty
        <ArrowRightOutlined
          style={{ marginLeft: 8, cursor: 'pointer', color: '#1890ff' }}
          title="Copy All Planned Qty to Issue Today"
          onClick={() => {
            const newArr = rawMaterials.map((record: any) => {
              const qty = Number(record?.quantity || 0);
              let error = false;

              if (record?.isReject) {
                const availableQty = getAllRejectStoreItemsData?.[record.store?.replaceAll("-fromrejectstore", "")]?.[record.itemId] || 0;
                if (availableQty / (record?.conversionFactor || 1) < qty) {
                  error = true;
                }
              } else {
                const availableQty = storewiseItems?.[record.store]?.[record.itemId] || 0;
                if (availableQty / (record?.conversionFactor || 1) < qty) {
                  error = true;
                }
              }

              return {
                ...record,
                issuedToday: qty,
                error
              };
            });
            setRawMaterials(newArr);
          }}
        />
      </div>,
      dataIndex: 'plannedQty',
      render: (text: string, record: any, index: number) => {
        return <span>{record?.quantity?.toFixed(3)}</span>
      }
    },
    {
      title: 'Consumed Qty',
      dataIndex: 'issuedQty',
      render: (text: string, record: any, index: number) => {
        return <span>{((record?.issuedQuantity || 0) + (record.consumedQuantity || 0)).toFixed(3)}</span>
      }
    },
    {
      title: 'Issue Today',
      dataIndex: 'issueToday',
      width: '250px',
      render: (text: string, record: any, index: number) => {
        return <>
          <Input min={0} className="input" onChange={(e) => {

            if (!e.target.value) {
              const arr = [...rawMaterials];
              arr[index] = {
                ...arr[index],
                issuedToday: ''
              }
              setRawMaterials(arr);
            }

            let error = false;

            if (record?.isReject) {
              const availableQty = getAllRejectStoreItemsData?.[record.store?.replaceAll("-fromrejectstore", "")]?.[record.itemId] || 0;
              if (availableQty / (record?.conversionFactor || 1) < Number(e.target.value)) {
                error = true;
              }
            } else {
              const availableQty = storewiseItems?.[record.store]?.[record.itemId] || 0;
              if (availableQty / (record?.conversionFactor || 1) < Number(e.target.value)) {
                error = true;
              }
            }
            const arr = [...rawMaterials];
            arr[index] = {
              ...arr[index],
              issuedToday: Number(e.target.value),
              error
            }
            setRawMaterials(arr);
          }} value={record?.issuedToday || 0} type='number' placeholder='Enter Quantity' /><br />
          {record?.error && <span style={{ color: '#ff0000' }}>Out of stock</span>}
        </>
      }
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space>
          <Popconfirm
            title="Are you sure to delete this Row?"
            onConfirm={() => removeRowsHandler(record, 'rawMaterial')}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="actionIcons"
              icon={<DeleteOutlined />}
              danger
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const productionProcessColumn: any = [
    {
      title: '#',
      dataIndex: 'key',
      width: 50,
      render: (text: string, record: any, index: number) => <span>{index + 1}</span>
    },
    {
      title: 'Operation step',
      dataIndex: 'step',
      render: (text: string, record: any, index: number) => <span>{record?.processName}</span>
    },
    {
      title: 'Description',
      dataIndex: 'resource',
      render: (text: string, record: any, index: number) => <span>{record?.description}</span>
    },
    {
      title: 'Finished Good',
      dataIndex: 'finishedGood',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
      render: (text: any, record: any) => {
        return <span>{finishedGoodMap[record?.productionId]?.itemName}</span>
      }
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          Planned Time
          <br />
          (DD:HH:MM:SS)
        </div>
      ),
      dataIndex: 'duration',
      render: (text: string, record: any, index: number) => <span>{record?.plannedTime}</span>
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          Time Consumed So Far
          <br />
          (DD:HH:MM:SS)
        </div>
      ),
      dataIndex: 'timeConsumed',
      render: (text: string, record: any, index: number) => {
        // Helper to parse time string with optional days
        const parseTime = (timeStr?: string) => {
          if (!timeStr) return [0, 0, 0, 0]; // [days, hours, minutes, seconds]

          const parts = timeStr.split(':').map(Number);
          if (parts?.length === 4) {
            // Format: DD:HH:MM:SS
            return parts;
          } else if (parts?.length === 3) {
            // Format: HH:MM:SS, assume 0 days
            return [0, ...parts];
          } else {
            // Invalid format fallback
            return [0, 0, 0, 0];
          }
        };

        const [d1, h1, m1, s1] = parseTime(record?.currentPlannedTime);
        const [d2, h2, m2, s2] = parseTime(record?.totalPlannedTime);

        let seconds = s1 + s2;
        let minutes = m1 + m2 + Math.floor(seconds / 60);
        let hours = h1 + h2 + Math.floor(minutes / 60);
        let days = d1 + d2 + Math.floor(hours / 24);

        seconds = seconds % 60;
        minutes = minutes % 60;
        hours = hours % 24;

        const format = (num: number) => String(num).padStart(2, '0');

        const time = `${format(days)}:${format(hours)}:${format(minutes)}:${format(seconds)}`;
        return <span>{time || '00:00:00:00'}</span>;
      }

    },
    {
      title: 'Total Planned Qty',
      dataIndex: 'totalProcess',
      render: (text: string, record: any, index: number) => {
        return <span>{bulkProductionData?.[index]?.finishedGoods[0]?.quantity}</span>
      }
    },
    {
      title: 'Total Processed Qty',
      dataIndex: 'totalProcess',
      render: (text: string, record: any, index: number) => {
        return <span>{record?.processCompleteOn || 0}</span>
      }
    },
    {
      title: 'Process Completion %',
      dataIndex: 'percent',
      render: (text: string, record: any, index: number) => {
        return <Flex wrap gap='small'>
          <Progress
            percent={Number((((record?.processCompleteOn || 0) * 100) / (finishedGoods[0].quantity))?.toFixed(2))}
            size='small'
          />
        </Flex>
      }
    },
    {
      title: "Today's Processed Qty",
      dataIndex: 'todayProcess',
      render: (text: string, record: any, index: number) => {
        return <Input value={record?.todayProcessQuantity || null} type='number' placeholder='Today Process Quantity' onChange={(e) => {
          const arr = [...process];
          arr[index] = {
            ...arr[index],
            todayProcessQuantity: (e.target.value)
          }
          setProcess(arr);
        }} />
      }
    },
    {
      title: 'Cost Per Hour',
      dataIndex: 'cost',
      width: '150px',
      render: (text: string, record: any, index: number) => {
        return (
          <Input
            type="number"
            placeholder="Enter per hour cost"
            onChange={(e) => {
              const arr = [...process];
              const val = Number(e.target.value) || 0;
              arr[index] = {
                ...arr[index],
                cost: val,
                amount: val,
              };
              setProcess(arr);
            }}
            value={record?.amount ?? (record?.perHourCost || "")}
          />
        );
      }
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          Actual Time
          <br />
          (DD:HH:MM:SS)
        </div>
      ),
      dataIndex: 'duration',
      width: '220px',
      render: (text: string, record: any, index: number) => {
        const [d1, h1, m1, s1] = record?.plannedTime.split(":").map(Number);
        const [d2, h2, m2, s2] = record?.totalPlannedTime?.split(":").map(Number) || [0, 0, 0, 0];

        const seconds1 = ((((d1 || 0) * 24) + h1) * 3600) + m1 * 60 + s1;
        const seconds2 = ((((d2 || 0) * 24) + h2) * 3600) + m2 * 60 + s2;

        let diffSeconds = seconds1 - seconds2;
        if (diffSeconds < 0) diffSeconds = 0;

        const days = Math.floor(diffSeconds / 86400);
        diffSeconds %= 86400;

        const hours = Math.floor(diffSeconds / 3600);
        diffSeconds %= 3600;

        const minutes = Math.floor(diffSeconds / 60);
        const seconds = diffSeconds % 60;

        const result = `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        return <Input
          maxLength={11}
          className='input'
          value={record?.currentTime || '00:00:00:00'}
          placeholder='DD:HH:MM:SS'
          onChange={(e) => {
            const val = e.target.value;
            if (/^[0-9:]*$/.test(val)) {
              const arr = [...process];
              arr[index] = {
                ...arr[index],
                currentTime: e.target.value
              }
              setProcess(arr);
            }
          }}
        />
      }
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space>
          <Popconfirm
            title="Are you sure to delete this Row?"
            onConfirm={() => removeRowsHandler(record, 'process')}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="actionIcons"
              icon={<DeleteOutlined />}
              danger
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const scrapLogColumns: any = [
    {
      title: "#",
      dataIndex: "key",
      width: 50,
      render: (text: string, record: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Item Id",
      dataIndex: "itemId",
    },
    {
      title: "Item Name",
      dataIndex: "itemName",
    },
    {
      title: 'Finished Good',
      dataIndex: 'finishedGood',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
      render: (text: any, record: any) => {
        return <span>{finishedGoodMap[record?.productionId]?.itemName}</span>
      }
    },
    {
      title: "UOM",
      dataIndex: "UOM",
      render: (text: string, record: any) => {
        return <span>{uomMap[record?.uom]}</span>;
      },
    },
    {
      title: "Planned Quantity",
      dataIndex: "quantity",
    },
    {
      title: "By-Product / Waste Qty",
      dataIndex: "quantity",
      width: "250px",
      render: (text: string, record: any) => {
        return <span>{record?.producedQuantity || 0}</span>;
      },
    },
    {
      title: "Store",
      dataIndex: "store",
      render: (text: string, record: any, index: number) => {
        return (
          <Select
            style={{ width: "100%" }}
            onChange={(value: string) => {
              const arr = [...scrapLogs];
              console.log(value)
              arr[index] = {
                ...arr[index],
                store: value,
                isReject: value.includes("-fromrejectstore") || false,
              };
              setScrapLogs(arr);
            }}
            placeholder="Select Store"
            className="input"
            value={record?.store || null}
          >
            {storesData?.map((store: any, index: number) => (
              <>
                {store?.storeType?.includes("1") && (
                  <Option key={store.id} value={store.name}>
                    {store.name} (Instock)
                  </Option>
                )}
                {store?.storeType?.includes("2") && (
                  <Option
                    key={`${store.id}-reject`}
                    value={`${store.name}-fromrejectstore`}
                  >
                    {store.name} (Reject)
                  </Option>
                )}
              </>
            ))}
          </Select>
        );
      },
    },
    {
      title: `Today's Leftover Qty`,
      dataIndex: "quantity",
      width: "250px",
      render: (text: string, record: any, index: number) => {
        return (
          <Input
            className="input"
            type="number"
            value={record?.value}
            placeholder="Enter Quantity"
            onChange={(e) => {
              const arr = [...scrapLogs];
              arr[index] = {
                ...arr[index],
                value: Number(e.target.value),
              };
              setScrapLogs(arr);
            }}
          />
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space>
          <Popconfirm
            title="Are you sure to delete this Row?"
            onConfirm={() => removeRowsHandler(record, 'leftOver')}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="actionIcons"
              icon={<DeleteOutlined />}
              danger
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const priceColumns: any = [
    {
      title: "#",
      dataIndex: "key",
      width: 50,
      render: (text: string, record: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Charges Name",
      dataIndex: "chargesName",
      render: (text: string, record: any, index: number) => (
        <span>{record?.chargesName}</span>
      ),
    },
    {
      title: 'Finished Good',
      dataIndex: 'finishedGood',
      width: ColumnWidths.DEFAULT,
      fixed: 'left',
      render: (text: any, record: any) => {
        return <span>{finishedGoodMap[record?.productionId]?.itemName}</span>
      }
    },
    {
      title: "Estimated Additional Cost",
      dataIndex: "estimatedCost",
      render: (text: string, record: any, index: number) => (
        <span>{record?.amount}</span>
      ),
    },
    {
      title: "Additional Cost So far",
      dataIndex: "estimatedCost",
      render: (text: string, record: any, index: number) => (
        <span>{(record?.totalCost || 0) + (record.currentCost || 0)}</span>
      ),
    },
    {
      title: "Today Cost",
      dataIndex: "price",
      render: (text: string, record: any, index: number) => {
        return (
          <Input
            className="input"
            value={record?.todayCost}
            onChange={(e) => {
              const arr = [...additionalCharges];
              arr[index] = {
                ...arr[index],
                todayCost: Number(e.target.value),
              };
              setAdditionalCharges(arr);
            }}
            type="number"
            placeholder="Enter Today Cost"
          />
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space>
          <Popconfirm
            title="Are you sure to delete this Row?"
            onConfirm={() => removeRowsHandler(record, 'additionalCharges')}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="actionIcons"
              icon={<DeleteOutlined />}
              danger
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const issueRawMaterials = () => {
    let count = 0;
    for (const element of rawMaterials) {
      if (element?.error) {
        notification.open({ message: 'Item Out of stock.', duration: 3, type: 'error' });
        return;
      }
    }
    for (const element of rawMaterials) {
      if (!element.issuedToday) {
        count++;
      }
    }
    if (count == rawMaterials?.length) {
      notification.open({ message: 'Issue Today is required Field.', type: 'warning', duration: 3 });
      return;
    }
    const rawMaterialData = [...rawMaterials]?.map(data => {
      return {
        ...data,
        issuedToday: data?.issuedToday || 0
      }
    });
    issueRawMaterial({
      companyId: Number(companyId),
      rawMaterialData,
      userId,
      by: usersData?.find(user => user.id == userId)?.name,
      bulkProductionId: bulkProductionData?.[0]?.bulkProduction?.id,
      bulkProductionNumber: bulkProductionData?.[0]?.bulkProduction?.productionId
    });
  }

  const handleUpdateProcess = () => {
    let i = 0;
    const timeRegex = /^(\d{2}):([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
    const temp = [...process]
    for (const element of temp) {
      if (!element.currentTime) element.currentTime = '00:00:00:00'
      if ((!element.todayProcessQuantity) && ((!element.amount && !element.perHourCost) || (!element.currentTime) || (!timeRegex.test(element.currentTime)))) i++;
      element.amount = element.amount || element.perHourCost
      if (element.currentTime === '00:00:00:00') element.currentTime = '';
    }
    if (i == process?.length) {
      notification.open({ message: 'Please Fill atleast one row with correct Actual Time.', duration: 3, type: 'warning' });
      return;
    }
    updateProcess({
      processData: temp,
      by: usersData?.find((user) => user.id == userId)?.name
    });
  }

  const handleUpdateCharges = () => {
    let i = 0;
    for (const element of additionalCharges) {
      if (!element.todayCost) i++;
    }
    if (i == additionalCharges?.length) {
      notification.open({
        message: "Please Fill atleast one row.",
        duration: 3,
        type: "warning",
      });
      return;
    }
    updateCost({ additionalChargesData: additionalCharges });
  };

  const handleUpdateScrapLogs = () => {
    let i = 0;
    for (const element of scrapLogs) {
      if (!element.value || !element.store) i++;
    }
    if (i == scrapLogs?.length) {
      notification.open({
        message: "Please Fill atleast one row.",
        duration: 3,
        type: "warning",
      });
      return;
    }
    updateScrapLogsStatus({
      scrapLogs: scrapLogs,
      companyId,
      bulkProductionId: bulkProductionData?.[0]?.bulkProduction?.id,
      bulkProductionNumber: bulkProductionData?.[0]?.bulkProduction?.productionId
    });
  };

  const saveGoods = () => {
    const currentProductionId = finishedGoods[testIndex]?.productionId
    saveFinishedGoods({
      process: process?.filter((data: { productionId: number }) => data.productionId == currentProductionId),
      rawMaterials: rawMaterials?.filter((data: { productionId: number }) => data.productionId == currentProductionId),
      additionalCharges: additionalCharges?.filter((data: { productionId: number }) => data.productionId == currentProductionId),
      store,
      rejectStore,
      finishedGoods: finishedGoods?.filter((data: { productionId: number }) => data.productionId == currentProductionId),
      passedQty: Number(passedQty), rejectQty: finishedGoods[testIndex]?.quantityToTest - (Number(passedQty) || 0),
      companyId: Number(companyId),
      // batchData: inlineBatchData, 
      userId,
      by: usersData?.find(user => user.id == userId)?.name,
      bulkProductionId: bulkProductionData?.[0]?.bulkProduction?.id,
      bulkProductionNumber: bulkProductionData?.[0]?.bulkProduction?.productionId
    });
  }

  const updateStatus = (value: string) => {
    updateProductionStatus({
      isBulkProduction: true,
      status: Number(value),
      productionId: bulkProductionData?.[0]?.bulkProduction?.id
    });
    setProductionStatus(Number(value));
  };

  const saveProductions = () => {
    const exactRawMaterial = settingData?.exactRawMaterial || false;

    let i = 0;
    for (const element of finishedGoods) {
      if (!element?.todaysProduction) i++;
      else {
        const rms = rawMaterialMap?.[element.productionId] || [];
        const allMissingIssuedQuantity = rms.every((element: { issuedQuantity: number }) => !element.issuedQuantity);

        if (allMissingIssuedQuantity && !exactRawMaterial) {
          notification.open({ message: 'Issued Atleast one Raw Material.', duration: 3, type: 'warning' });
          return;
        }

        if (exactRawMaterial) {
          for (const rm of rms) {
            const bomRequiredPerUnit = rm.quantity / element.quantity;
            const totalTestedQty = (Number(element.producedQuantity) || 0) + (Number(element.todaysProduction) || 0);
            const expectedRequiredQty = (totalTestedQty * bomRequiredPerUnit) || 0;

            if (Number(((rm.issuedQuantity || 0) + (rm.consumedQuantity || 0))?.toFixed?.(3)) < Number(expectedRequiredQty?.toFixed?.(3))) {
              notification.open({
                message: `Exact Raw Material Quantity mismatch.`,
                duration: 3,
                type: 'warning'
              });
              return;
            }
          }
        }
      }
    }
    if (i == finishedGoods?.length) {
      notification.open({ message: 'Please Fill atleast one row.', duration: 3, type: 'warning' });
      return;
    }
    saveProduction({
      finishedGoods,
      by: usersData?.find(user => user.id == userId)?.name,
      companyId: Number(companyId)
    });
  }

  const handleUpdateTable = () => {
    if (updateTable === 'Raw Material' || updateTable == 'By-Product / Waste Materials') {
      const payload = [];
      for (const element of addRows) {
        const { store, selectedItemId, plannedQty } = element;
        if ((!plannedQty || !selectedItemId || !store || !element.productionId)) {
          notification.open({ message: 'Please fill All Fields', duration: 3, type: 'warning' });
          return;
        }
        const selectedItem = itemsData.filter((item: { itemId: string }) => item.itemId == selectedItemId);
        payload.push({
          itemId: selectedItem[0]?.itemId,
          itemName: selectedItem[0]?.itemName,
          uom: selectedItem[0]?.metricsUnit,
          productionId: element.productionId,
          plannedQty,
          store,
        });
      }
      updateTableData({
        data: payload,
        updateTableType: updateTable === 'By-Product / Waste Materials' ? "Left Over Item" : updateTable,
        companyId: Number(companyId),
        by: usersData?.find(user => user.id == userId)?.name
      });
    }

    if (updateTable === 'Additional Charges') {
      const payload = [];
      for (const element of addCharges) {
        if ((!element?.chargesName || !element?.chargesCost || !element.productionId)) {
          notification.open({ message: 'Please fill All Fields', duration: 3, type: 'warning' });
          return;
        }
        payload.push({
          productionId: element.productionId,
          chargesName: element.chargesName,
          amount: element.chargesCost,
        });
      }
      updateTableData({
        data: payload,
        updateTableType: updateTable,
        companyId: Number(companyId),
        by: usersData?.find(user => user.id == userId)?.name
      });
    }

    if (updateTable === 'Process') {
      const payload = [];
      const timeRegex = /^(\d{2}):([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
      for (const element of addProcess) {
        if ((!element?.plannedTime || !element?.chargesCost || !element?.selectedProcess || !timeRegex.test(element?.plannedTime || !element.productionId))) {
          notification.open({ message: 'Please fill All Fields with correct Planned time format.', duration: 3, type: 'warning' });
          return;
        }
        const selectedProcessName = getProductionProcessState?.data?.data?.filter((data: any) => data.id == element?.selectedProcess)
        payload.push({
          productionId: element.productionId,
          plannedTime: element?.plannedTime,
          description: selectedProcessName?.[0]?.description,
          processName: selectedProcessName?.[0]?.processName,
          amount: element?.chargesCost,
        });
      }
      updateTableData({
        data: payload,
        companyId: Number(companyId),
        updateTableType: updateTable,
        by: usersData?.find(user => user.id == userId)?.name
      });
    }
  }

  const removeRowsHandler = (record: any, type: string) => {
    removeRows({
      type,
      id: record.id,
      by: usersData?.find(user => user.id == userId)?.name,
      name: record?.itemName || record?.processName || record?.chargesName,
      productionId: record.productionId
    });
  }

  useEffect(() => {
    getUOM({ companyId: Number(companyId) });
    getStores({ companyId: Number(companyId) });
    getItems({ companyId: Number(companyId) });
    getProductionProcess({ companyId: Number(companyId) });
    getAllRejectStoreItems({ companyId: Number(companyId) });
    getUsers({ companyId: Number(companyId), admin: true });
    getSetting({ companyId: Number(companyId) });
  }, [companyId]);

  useEffect(() => {
    const obj = UOMData?.reduce((acc: any, current: any) => {
      acc[current.id] = current.name;
      return acc;
    }, {});
    setUomMap(obj);
  }, [UOMData]);

  useEffect(() => {
    getBulkProductions({ productionId });
  }, [
    productionId,
    issueRawMaterialLoading,
    updateProcessLoading,
    updateCostLoading,
    saveFinishedGoodsLoading,
    updateScrapLogLoading,
    saveProductionLoading,
    updateTableLoading,
    updateProductionStatusMsg,
    removeRowMsg
  ]);

  useEffect(() => {
    if (bulkProductionData?.length) {
      const statuses = bulkProductionData
        .map((item: any) => Number(item?.production?.status))
        .filter((status: number) => !Number.isNaN(status));

      if (statuses.length) {
        if (statuses.includes(2)) {
          setProductionStatus(2);
        } else if (statuses.every((status: number) => status === 4)) {
          setProductionStatus(4);
        } else if (statuses.every((status: number) => status === 3)) {
          setProductionStatus(3);
        } else if (statuses.every((status: number) => status === 1)) {
          setProductionStatus(1);
        }
      }
      const rawMaterialObj: any = {};
      let cost = 0;
      const obj = bulkProductionData.reduce((acc: any, curr: any) => {
        cost += (curr?.finishedGoods?.[0]?.cost || 0)
        rawMaterialObj[curr?.production?.id] = curr.rawMaterials || [];
        acc[curr?.production?.id] = { itemId: curr?.finishedGoods[0]?.itemId, itemName: curr?.finishedGoods[0]?.itemName }
        return acc;
      }, {});
      setCostOfProduction(cost);
      setFinishedGoodMap(obj);
      setRawMaterialMap(rawMaterialObj);
      setProductions(bulkProductionData);

      const allFinishedGoods = bulkProductionData?.flatMap(
        (prod: any) => prod.finishedGoods || []
      );
      const allRawMaterials = bulkProductionData?.flatMap(
        (prod: any) => prod.rawMaterials || []
      );
      const allProcesses = bulkProductionData?.flatMap(
        (prod: any) => prod.process || []
      );
      const allScrapLogs = bulkProductionData?.flatMap(
        (prod: any) => prod.scrapLogs || []
      );
      const allAdditionalCharges = bulkProductionData?.flatMap(
        (prod: any) => prod.additionalCharges || []
      );

      setFinishedGoods(allFinishedGoods);
      setRawMaterials(allRawMaterials);
      setProcess(allProcesses);
      setScrapLogs(allScrapLogs);
      setAdditionalCharges(allAdditionalCharges);
    }
  }, [bulkProductionData]);

  useEffect(() => {
    if (Array.isArray(storesData) && storesData?.length) {
      const storeIds = storesData?.map((data) => data.id);
      getAllStoresWithItems({ storeIds });
    }
    getAllRejectStoreItems({ companyId: Number(companyId) });
  }, [
    storesData,
    issueRawMaterialLoading,
    updateProcessLoading,
    updateCostLoading,
    saveFinishedGoodsLoading,
    updateScrapLogLoading,
    saveProductionLoading,
    updateTableLoading,
  ]);

  useEffect(() => {
    const storeNameMap = storesData?.reduce((acc: any, store: any) => {
      acc[store.id] = store.name;
      return acc;
    }, {});
    const obj: any = {};
    for (const element of getAllStoresWithItemsData) {
      for (const store of element) {
        if (obj[storeNameMap[store.storeId]]) {
          obj[storeNameMap[store.storeId]][store.itemId.itemId] =
            store.quantity;
        } else {
          obj[storeNameMap[store.storeId]] = {};
          obj[storeNameMap[store.storeId]][store.itemId.itemId] =
            store.quantity;
        }
      }
    }
    setStoreWiseItems(obj);
  }, [getAllStoresWithItemsData]);

  useEffect(() => {
    if (updateTableMsg) {
      notification.open({
        message: "Data Added Successfully.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "UPDATE_TABLE_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
      setUpdateTable("");
      setStore("");
      setPlannedQty(1);
      setSelectedItemId("");
      setChargesCost(0);
      setChargesName("");
      setPlannedTime("");
      setSelectedProcesses("");
      setAddRows([]);
      setAddCharges([]);
      setAddProcess([]);
    }

    if (issueRawMaterialSuccess) {
      notification.open({
        message: "Raw Material Issued.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "ISSUE_RAW_MATERIAL_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (productionUpdateMsg) {
      const arr = [...process].map((data: any) => ({
        ...data,
        amount: null,
        currentTime: null,
      }));

      notification.open({
        message: "Production hours Updated.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "UPDATE_PROCESS_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (costUpdateMsg) {
      notification.open({
        message: "Additional Charges Added.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "UPDATE_COST_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (finishedGoodsMsg) {
      notification.open({
        message: "Finished Goods Added Successfully",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "SAVE_FINISHED_GOODS_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
      setIsDrawerOpen(false);
      setStore("");
      setRejectStore("");
      setTodaysProduction(0);
    }

    if (updateProductionStatusMsg) {
      notification.open({
        message: "Production Status Updated.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "UPDATE_PRODUCTION_STATUS_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (updateScrapLogMsg) {
      notification.open({
        message: "Leftover Material Added.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "UPDATE_SCRAP_LOGS_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (saveProductionMsg) {
      notification.open({
        message: "Production Saved.",
        type: "success",
        duration: 3,
      });
      dispatch({
        type: "SAVE_PRODUCTION_SUCCESS",
        payload: {
          responseData: {
            message: "",
          },
        },
      });
    }

    if (removeRowMsg) {
      notification.open({ message: 'Row removed Successfully.', type: 'success', duration: 3 });
      dispatch({
        type: 'REMOVE_ROWS_SUCCESS', payload: {
          responseData: {
            message: ''
          }
        }
      });
    }
  }, [
    issueRawMaterialSuccess,
    productionUpdateMsg,
    costUpdateMsg,
    finishedGoodsMsg,
    updateProductionStatusMsg,
    updateScrapLogMsg,
    saveProductionMsg,
    updateTableMsg,
    removeRowMsg
  ]);

  return (
    <Layout>
      <Loader
        loading={
          loading ||
          issueRawMaterialLoading ||
          updateProcessLoading ||
          updateCostLoading ||
          saveFinishedGoodsLoading ||
          updateProductionStatusLoading ||
          updateScrapLogLoading ||
          saveProductionLoading || removeRowLoading
        }
      />
      <Content style={{ padding: 24, overflowY: "auto" }}>
        <div style={{ textAlign: 'right', marginBottom: '5px' }}>
          <Button type="link"
            onClick={() => {
              setOpenHistory(true);
            }}>
            <ClockCircleOutlined />
            View History
          </Button>
          <Button type="link"
            onClick={() => {
              window.print();
            }}>
            <PrinterOutlined />
            Print
          </Button>
        </div>
         <ProductionHistory
            openHistory={openHistory}
            setOpenHistory={setOpenHistory}
            bulkProductionId={productionId || ''}
            navigationId={bulkProductionData?.[0]?.bulkProduction?.productionId}
            isBulkProduction={true}
                />
        <Drawer
          title={"Add Production"}
          width={1000}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
          open={drawerOpen}
          styles={{
            body: {
              paddingBottom: 80,
            },
          }}
          extra={
            <Space>
              <Button
                onClick={() => {
                  setIsDrawerOpen(false);
                }}
                className="buttomCancelMobView"
              >
                Cancel
              </Button>
              <Button
                disabled={
                  !store ||
                  (finishedGoods[testIndex]?.quantityToTest != passedQty &&
                    !rejectStore) ||
                  !passedQty
                }
                onClick={saveGoods}
                type="primary"
              >
                Save
              </Button>
            </Space>
          }
        >
          <Row gutter={16}>
            <Col span={12}>
              <Text>Actual Qty</Text>
              <Input value={finishedGoods[testIndex]?.quantityToTest} disabled />
            </Col>
            <Col span={12}>
              <Text>Passed Qty</Text>
              <Input
                placeholder="Enter Passed Qty"
                onChange={(e) => {
                  if (
                    Number(e.target.value) < 0 ||
                    Number(e.target.value) > finishedGoods[testIndex]?.quantityToTest
                  )
                    return;
                  setPassedQty(Number(e.target.value));
                }}
                value={passedQty}
              />
            </Col>
          </Row>

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={12}>
              <Text>Reject Qty</Text>
              <Input
                placeholder="Enter Reject Qty"
                defaultValue={0}
                disabled
                value={finishedGoods[testIndex]?.quantityToTest - (passedQty || 0)}
              />
            </Col>
            <Col span={12}>
              <Text>Store</Text>
              <Select
                style={{ width: "100%" }}
                onChange={(value: string) => {
                  setStore(value);
                }}
                placeholder="Select Store"
                value={store || null}
              >
                {storesData?.map((store: any, index: number) => (
                  <Option key={store.id} value={store.name}>
                    {store.name || null}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={12}>
              <Text>Reject Store</Text>
              <Select
                style={{ width: "100%" }}
                onChange={(value: string) => {
                  setRejectStore(value);
                }}
                placeholder="Select Reject Store"
                value={rejectStore || null}
              >
                {storesData?.map((store: any, index: number) => (
                  <Option key={store.id} value={store.name}>
                    {store.name}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Drawer>
        <Drawer
          title={`Add ${updateTable}`}
          width={1000}
          onClose={() => {
            setUpdateTable("");
          }}
          open={updateTable ? true : false}
          styles={{
            body: {
              paddingBottom: 80,
            },
          }}
          extra={
            <Space>
              <Button
                onClick={() => {
                  setUpdateTable("");
                }}
                className="buttomCancelMobView"
              >
                Cancel
              </Button>
              <Button onClick={handleUpdateTable} type="primary">
                Save
              </Button>
            </Space>
          }
        >
          {(updateTable === "Raw Material" ||
            updateTable === "By-Product / Waste Materials") && (
              <>
                <Button
                  type="primary"
                  className="mb-2"
                  onClick={() => {
                    for (const element of addRows) {
                      if (
                        !element?.selectedItemId ||
                        !element.plannedQty ||
                        !element.store
                      )
                        return;
                    }
                    const arr = [
                      ...addRows,
                      { plannedQty: 1, store: null, selectedItemId: null },
                    ];
                    setAddRows(arr);
                  }}
                >
                  Add new Row
                </Button>
                <Table
                  columns={[
                    {
                      title: "Finished Good",
                      dataIndex: "finishedGood",
                      render: (text: string, record: any, index: number) => {
                        return <Select
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input: any, option: any) =>
                            (option?.children || '')?.toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ width: '200px' }}
                          onChange={(value: string) => {
                            const arr = [...addRows];
                            arr[index] = {
                              ...arr[index],
                              productionId: value,
                            };
                            setAddRows(arr);
                          }}
                          placeholder='Select Finished Good'>
                          {
                            finishedGoods?.map((data: any) => {
                              return <Option value={data.productionId}>{data.itemName}</Option>
                            })
                          }
                        </Select>
                      },
                    },
                    {
                      title: "Planned Qty",
                      dataIndex: "plannedQty",
                      render: (text: string, record: any, index: number) => {
                        return (
                          <Input
                            type="number"
                            value={record.plannedQty}
                            onChange={(e) => {
                              const arr = [...addRows];
                              arr[index] = {
                                ...arr[index],
                                plannedQty: Number(e.target.value),
                              };
                              setAddRows(arr);
                            }}
                          />
                        );
                      },
                    },
                    {
                      title: "Select Item",
                      dataIndex: "selectedItem",
                      render: (text: string, record: any, index: number) => {
                        return (
                          <Select
                            filterOption={(
                              input: string,
                              option?: { children?: React.ReactNode }
                            ) =>
                              option?.children &&
                                typeof option.children === "string"
                                ? option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                                : false
                            }
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(value: string) => {
                              const arr = [...addRows];
                              arr[index] = {
                                ...arr[index],
                                selectedItemId: value,
                              };
                              setAddRows(arr);
                            }}
                            placeholder="Select Item"
                            value={record?.selectedItemId || null}
                          >
                            {itemsData
                              ?.filter(
                                (item: any) =>
                                  item?.itemId != finishedGoods?.[0]?.itemId
                              )
                              ?.map((item: any, index: number) => (
                                <Option
                                  key={index}
                                  value={item.itemId}
                                  label={item.itemName}
                                >
                                  {item.itemName || null}
                                </Option>
                              ))}
                          </Select>
                        );
                      },
                    },
                    {
                      title: "Store",
                      dataIndex: "selectedStore",
                      render: (text: string, record: any, index: number) => {
                        return (
                          <Select
                            style={{ width: "100%" }}
                            onChange={(value: string) => {
                              const arr = [...addRows];
                              arr[index] = {
                                ...arr[index],
                                store: value,
                              };
                              setAddRows(arr);
                            }}
                            placeholder="Select Store"
                            value={record?.store || null}
                          >
                            {storesData?.map((store: any, index: number) => (
                              <Option key={store.id} value={store.name}>
                                {store.name || null}
                              </Option>
                            ))}
                          </Select>
                        );
                      },
                    },
                    {
                      title: "Actions",
                      dataIndex: "actions",
                      render: (text: string, record: any, index: number) => {
                        return addRows?.length > 1 ? (
                          <DeleteOutlined
                            onClick={() => {
                              const arr = addRows.filter(
                                (_: any, ind: number) => ind !== index
                              );
                              setAddRows(arr);
                            }}
                          />
                        ) : null;
                      },
                    },
                  ]}
                  dataSource={addRows}
                  pagination={false}
                  bordered
                />
              </>
            )}
          {updateTable === "Additional Charges" && (
            <>
              <Button
                type="primary"
                className="mb-2"
                onClick={() => {
                  for (const element of addCharges) {
                    if (!element?.chargesName || !element.chargesCost) return;
                  }
                  const arr = [
                    ...addCharges,
                    { chargesCost: 0, chargesName: null },
                  ];
                  setAddCharges(arr);
                }}
              >
                Add new Row
              </Button>
              <Table
                columns={[
                  {
                    title: "Finished Good",
                    dataIndex: "finishedGood",
                    render: (text: string, record: any, index: number) => {
                      return <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, option: any) =>
                          (option?.children || '')?.toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: '200px' }}
                        onChange={(value: string) => {
                          const arr = [...addCharges];
                          arr[index] = {
                            ...arr[index],
                            productionId: value,
                          };
                          setAddCharges(arr);
                        }}
                        placeholder='Select Finished Good'>
                        {
                          finishedGoods?.map((data: any) => {
                            return <Option value={data.productionId}>{data.itemName}</Option>
                          })
                        }
                      </Select>
                    },
                  },
                  {
                    title: "Charges Name",
                    dataIndex: "chargesName",
                    render: (text: string, record: any, index: number) => {
                      return (
                        <Input
                          type="text"
                          value={record?.chargesName || null}
                          onChange={(e) => {
                            const arr = [...addCharges];
                            arr[index] = {
                              ...arr[index],
                              chargesName: e.target.value,
                            };
                            setAddCharges(arr);
                          }}
                          placeholder="Add Charges Name"
                        />
                      );
                    },
                  },
                  {
                    title: "Cost",
                    dataIndex: "cost",
                    render: (text: string, record: any, index: number) => {
                      return (
                        <Input
                          type="number"
                          value={record?.chargesCost || null}
                          onChange={(e) => {
                            const arr = [...addCharges];
                            arr[index] = {
                              ...arr[index],
                              chargesCost: Number(e.target.value),
                            };
                            setAddCharges(arr);
                          }}
                          placeholder="Add Charges Cost"
                        />
                      );
                    },
                  },
                  {
                    title: "Actions",
                    dataIndex: "actions",
                    render: (text: string, record: any, index: number) => {
                      return addCharges?.length > 1 ? (
                        <DeleteOutlined
                          onClick={() => {
                            const arr = addCharges.filter(
                              (_: any, ind: number) => ind !== index
                            );
                            setAddCharges(arr);
                          }}
                        />
                      ) : null;
                    },
                  },
                ]}
                dataSource={addCharges}
                pagination={false}
                bordered
              />
            </>
          )}
          {updateTable === "Process" && (
            <>
              <Button
                type="primary"
                className="mb-2"
                onClick={() => {
                  for (const element of addProcess) {
                    if (
                      !element?.selectedProcess ||
                      !element.chargesCost ||
                      !element?.plannedTime
                    )
                      return;
                  }
                  const arr = [
                    ...addProcess,
                    {
                      chargesCost: 0,
                      selectedProcess: null,
                      plannedTime: null,
                    },
                  ];
                  setAddProcess(arr);
                }}
              >
                Add new Row
              </Button>
              <Table
                columns={[
                  {
                    title: "Finished Good",
                    dataIndex: "finishedGood",
                    render: (text: string, record: any, index: number) => {
                      return <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, option: any) =>
                          (option?.children || '')?.toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: '200px' }}
                        onChange={(value: string) => {
                          const arr = [...addProcess];
                          arr[index] = {
                            ...arr[index],
                            productionId: value,
                          };
                          setAddProcess(arr);
                        }}
                        placeholder='Select Finished Good'>
                        {
                          finishedGoods?.map((data: any) => {
                            return <Option value={data.productionId}>{data.itemName}</Option>
                          })
                        }
                      </Select>
                    },
                  },
                  {
                    title: 'Select Proceess',
                    dataIndex: 'selectProceess',
                    render: (text: string, record: any, index: number) => {
                      return <Select
                        filterOption={(input: string, option?: { children?: React.ReactNode }) =>
                          typeof option?.children === 'string' &&
                          option.children.toLowerCase().includes(input.toLowerCase())
                        }
                        showSearch
                        style={{ width: '100%' }}
                        onChange={(value: string) => {
                          const arr = [...addProcess];
                          arr[index] = {
                            ...arr[index],
                            selectedProcess: value
                          }
                          setAddProcess(arr);
                        }}
                        placeholder='Select Process'
                        value={record?.selectedProcess || null}>
                        {
                          (Array.isArray(getProductionProcessState?.data?.data) ? getProductionProcessState?.data?.data : [])?.filter((item: any) => !process?.map((pro: any) => pro.processName)?.includes(item?.processName))?.map((process: any, index: number) => (
                            <Option key={index} value={process.id} label={process.processName}>{process.processName || null}</Option>
                          ))
                        }
                      </Select>
                    }
                  },
                  {
                    title: 'Planned Time (DD:HH:MM:SS)',
                    dataIndex: 'plannedTime',
                    render: (text: string, record: any, index: number) => {
                      return <Input
                        maxLength={11}
                        placeholder='DD:HH:MM:SS'
                        style={{ width: '100%' }}
                        className='input'
                        value={record?.plannedTime || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^[0-9:]*$/.test(val)) {
                            const arr = [...addProcess];
                            arr[index] = {
                              ...arr[index],
                              plannedTime: val
                            }
                            setAddProcess(arr);
                          }
                        }}
                      />

                    }
                  },
                  {
                    title: 'Cost/Hour',
                    dataIndex: 'cost',
                    render: (text: string, record: any, index: number) => {
                      return <Input
                        type='number'
                        value={record?.chargesCost}
                        onChange={(e) => {
                          const arr = [...addProcess];
                          arr[index] = {
                            ...arr[index],
                            chargesCost: Number(e.target.value)
                          }
                          setAddProcess(arr);
                        }}
                        placeholder='Add Charges Cost' />
                    }
                  },
                  {
                    title: 'Actions',
                    dataIndex: 'actions',
                    render: (text: string, record: any, index: number) => {
                      return addProcess?.length > 1 ? (
                        <DeleteOutlined
                          onClick={() => {
                            const arr = addProcess.filter((_: any, ind: number) => ind !== index);
                            setAddProcess(arr);
                          }}
                        />
                      ) : null;
                    }
                  },
                ]}
                dataSource={addProcess}
                pagination={false}
                bordered
              />
            </>
          )}
        </Drawer>
        <Card id='documentContainer' bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
            <Col className='hideOnPrint' span={8}>
              <Text>Show Cost of Production</Text>
              <br />
              <Switch
                checked={showColumns}
                onChange={(checked) => setshowColumns(checked)}
              />
            </Col>
            <Col span={8}>
              <Text>Production Id</Text>
              <br />
              <div>{bulkProductionData?.[0]?.bulkProduction?.productionId}</div>
            </Col>
            <Col span={8}>
              <Text>Status</Text>
              <br />
              <Select
                style={{ width: '200px', borderRadius: 4 }}
                value={productionStatus}
                onChange={updateStatus}
              >
                <Option key={1} value={1}>In Planning</Option>
                <Option key={2} value={2}>Ongoing</Option>
                <Option key={3} value={3}>On Hold</Option>
                <Option key={4} value={4}>Completed</Option>
              </Select>
            </Col>


          </div>
          <div>
            <Col span={8}>
              {showColumns && <>
                <Text type="secondary">Cost of Production So far</Text>
                <br />
                <Text strong>₹ {costOfProduction?.toLocaleString('en-IN', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</Text>
              </>}
            </Col>
          </div>

          <div style={{ marginTop: 40 }}>
            <div className="viewProductioncontainer">
              <Title level={4}>Finished Goods</Title>
              <Button
                className='hideOnPrint'
                disabled={bulkProductionData?.production?.status == 4}
                onClick={saveProductions}
                type="primary"
              >
                Save
              </Button>
            </div>
            <Table
              columns={finishedGoodColumns}
              dataSource={finishedGoods}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
            />
          </div>

          <div style={{ marginTop: 40 }}>
            <div className="viewProductioncontainer">
              <Title level={4}>Raw Materials</Title>
              <Button
                disabled={bulkProductionData?.production?.status == 4}
                onClick={issueRawMaterials}
                type="primary"
                className='hideOnPrint'
              >
                Issue
              </Button>
            </div>
            <Table
              columns={rawMaterialColumns}
              dataSource={rawMaterials}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
            />
            <Button
              disabled={bulkProductionData?.production?.status == 4}
              onClick={() => {
                setUpdateTable("Raw Material");
                setAddRows([{ plannedQty: 1, selectedItem: "", store: "" }]);
              }}
              type="link"
              icon={<PlusOutlined />}
              className='hideOnPrint'
            >
              Add row
            </Button>
          </div>

          <div style={{ marginTop: 40 }}>
            <div className="viewProductioncontainer">
              <Title level={4}>Production Processes</Title>
              <Button
                disabled={bulkProductionData?.production?.status == 4}
                onClick={handleUpdateProcess}
                type="primary"
                className='hideOnPrint'
              >
                Save
              </Button>
            </div>
            {process?.length > 0 ? <Table
              columns={productionProcessColumn}
              dataSource={process || []}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
            /> : <></>}
            <Button
              disabled={bulkProductionData?.production?.status == 4}
              onClick={() => {
                setUpdateTable("Process");
                setAddProcess([
                  { chargesCost: 0, selectedProcess: null, plannedTime: null },
                ]);
              }}
              type="link"
              icon={<PlusOutlined />}
              className='hideOnPrint'
            >
              Add row
            </Button>
          </div>

          <div style={{ marginTop: 40 }}>
            <div className="viewProductioncontainer">
              <Title level={4}>By-Product / Waste Materials</Title>
              {scrapLogs?.length ? (
                <Button
                  disabled={bulkProductionData?.production?.status == 4}
                  onClick={handleUpdateScrapLogs}
                  type="primary"
                  className='hideOnPrint'
                >
                  Save
                </Button>
              ) : (
                <></>
              )}
            </div>
            {scrapLogs?.length ? (
              <Table
                columns={scrapLogColumns}
                dataSource={scrapLogs || []}
                pagination={false}
                bordered
                scroll={{ x: "max-content" }}
              />
            ) : (
              <></>
            )}
            <Button
              disabled={bulkProductionData?.production?.status == 4}
              onClick={() => {
                setUpdateTable("By-Product / Waste Materials");
                setAddRows([{ plannedQty: 1, selectedItem: "", store: "" }]);
              }}
              type="link"
              icon={<PlusOutlined />}
              className='hideOnPrint'
            >
              Add row
            </Button>
          </div>

          <div style={{ marginTop: 40 }}>
            <div className="viewProductioncontainer">
              <Title level={4}>Additional Charges</Title>
              <Button
                disabled={bulkProductionData?.production?.status == 4}
                onClick={handleUpdateCharges}
                type="primary"
                className='hideOnPrint'
              >
                Save
              </Button>
            </div>
            {additionalCharges?.length > 0 ? <Table
              columns={priceColumns}
              dataSource={additionalCharges || []}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
            /> : <></>}
            <Button
              disabled={bulkProductionData?.production?.status == 4}
              onClick={() => {
                setUpdateTable("Additional Charges");
                setAddCharges([{ chargesCost: 0, chargesName: null }]);
              }}
              type="link"
              icon={<PlusOutlined />}
              className='hideOnPrint'
            >
              Add row
            </Button>
          </div>
        </Card>
      </Content>
    </Layout >
  );
};

const mapStateToProps = (state: any) => ({
  bulkProductionData: state.api.getBulkProduction?.data?.productionsData,
  loading: state.api.getBulkProduction?.loading,
  companyId: state.api.login.data.companyId,
  UOMData: state.api.getUOM?.data,
  getAllStoresWithItemsData: state.api.getAllStoresWithItems.getAllStoresWithItemsData,
  storesData: state.api.getStore?.data,
  issueRawMaterialLoading: state.api.issueRawMaterial.loading,
  updateProcessLoading: state.api.updateProcess.loading,
  updateCostLoading: state.api.updateCost.loading,
  saveFinishedGoodsLoading: state.api.saveFinishedGoods.loading,
  issueRawMaterialSuccess: state.api.issueRawMaterial.data,
  productionUpdateMsg: state.api.updateProcess.message,
  costUpdateMsg: state.api.updateCost.message,
  finishedGoodsMsg: state.api.saveFinishedGoods.message,
  updateProductionStatusMsg: state.api.updateProductionStatus.message,
  updateProductionStatusLoading: state.api.updateProductionStatus.loading,
  updateScrapLogMsg: state.api.updateScrapLogs.message,
  updateScrapLogLoading: state.api.updateScrapLogs.loading,
  saveProductionLoading: state.api.saveProduction.loading,
  saveProductionMsg: state.api.saveProduction.message,
  itemsData: state.api.getItems?.data,
  updateTableMsg: state.api.updateTable.message,
  updateTableLoading: state.api.updateTable.loading,
  getProductionProcessState: state.api.getProductionProcess,
  getAllRejectStoreItemsData: state.api.getAllRejectStoreItems?.data,
  usersData: state.api.getUsers?.data,
  userId: state.api.login.data?.id,
  removeRowMsg: state.api.removeRows.message,
  removeRowLoading: state.api.removeRows.loading,
  settingData: state.api.getSetting?.data,
});

const mapDispatchToProps = (dispatch: any) => ({
  getBulkProductions: (payload: any) => dispatch(getBulkProductions(payload)),
  getUOM: (payload: any) => dispatch(getUOM(payload)),
  getAllStoresWithItems: (payload: any) => dispatch(getAllStoresWithItems(payload)),
  getStores: (payload: any) => dispatch(getStores(payload)),
  issueRawMaterial: (payload: any) => dispatch(issueRawMaterial(payload)),
  updateProcess: (payload: any) => dispatch(updateProcess(payload)),
  updateCost: (payload: any) => dispatch(updateCost(payload)),
  saveFinishedGoods: (payload: any) => dispatch(saveFinishedGoods(payload)),
  updateProductionStatus: (payload: any) => dispatch(updateProductionStatus(payload)),
  updateScrapLogsStatus: (payload: any) => dispatch(updateScrapLogsStatus(payload)),
  saveProduction: (payload: any) => dispatch(saveProduction(payload)),
  getItems: (payload: any) => dispatch(getItems(payload)),
  updateTableData: (payload: any) => dispatch(updateTableData(payload)),
  getProductionProcess: (payload: any) => dispatch(getProductionProcess(payload)),
  getAllRejectStoreItems: (payload: any) => dispatch(getAllRejectStoreItems(payload)),
  getUsers: (payload: any) => dispatch(getUsers(payload)),
  removeRows: (payload: any) => dispatch(removeRows(payload)),
  getSetting: (payload: any) => dispatch(getSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewBulkProduction);
